import React from 'react'

import AspectContainer from '../../../../components/AspectContainer/AspectContainer'
// @ts-expect-error — importing js
import { Button } from '../../../../components'

import useEventsQuery from '../../../../hooks/useEventsQuery'
import useEventSessionsQuery, {
  isLive,
  isPreviousNotOnDemand,
} from '../../../../hooks/useEventSessionsQuery'
import { useWebinarColors } from '../../../../hooks/useWebinarColors'
import { WebinarPanelComponent } from '../../../WebinarSidebarFeature/components'

import './DigitalEventCard.scss'

interface DigitalEventCardProps {
  liveId: string
  liveData: Record<string, any> // TODO:
  onClick?: () => void
}

// eslint-disable-next-line react/display-name
export default ({
  liveId,
  liveData,
  onClick = () => {},
}: DigitalEventCardProps) => {
  const isDigitalEvent = !!liveData.live_series_id

  const { data: events } = useEventsQuery({
    id: liveData.live_series_id,
    token: liveData.live_series_token,
    enabled: isDigitalEvent,
  })
  const event = events?.[0]
  const { data: eventSessions } = useEventSessionsQuery({
    id: liveData.live_series_id,
    excludeSessionId: liveId,
    refetchInterval: 10_000,
    token: liveData.live_series_token,
    enabled: isDigitalEvent,
    includePrivate: true,
    includeSpeakers: true,
  })

  const webinarColors = useWebinarColors()

  const numberOfSessions =
    eventSessions?.filter((session) => !isPreviousNotOnDemand(session))
      .length ?? 0
  const numberOfLiveSessions = eventSessions?.filter(isLive).length ?? 0
  const numberOfSessionsPrefix = numberOfSessions === 1 ? 'session' : 'sessions'

  return (
    <>
      {event && eventSessions && (
        <WebinarPanelComponent>
          <div className="content-enclosure">
            <div className="thumbnail">
              <AspectContainer>
                <img src={event.thumbnailUrl} alt="thumbnail" />
              </AspectContainer>
            </div>
            <div className="info-enclosure">
              <div className="title">{event.name}</div>
              <div className="count">
                {`${numberOfSessions} other ${numberOfSessionsPrefix}`}
                {numberOfLiveSessions > 0 && ` — ${numberOfLiveSessions} live`}
              </div>
            </div>
          </div>
          <Button
            type="button"
            style={{
              backgroundColor: webinarColors.accent,
              color: webinarColors.accent.contrast,
              borderColor: 'transparent',
            }}
            onClick={onClick}
            round
          >
            See sessions
          </Button>
        </WebinarPanelComponent>
      )}
    </>
  )
}
